export default "__VITE_ASSET__CzbwObGk__"